import React from 'react'
import { Platform, Pressable } from 'react-native'
import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import useAnimatedPress from '@ui/animated/useAnimatedPress'

export default function CreateAccountSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['staff'])
  const text = 'staff:panel.sections.createAccount'

  const onPress = () => router.navigate('/staff/create-customer')

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="flex-1"
    >
      <TileBlur
        variant="small"
        title={t(`${text}.title`)}
        desc={t(`${text}.desc`)}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label={t(`${text}.cta`)}
          />
        }
        glassProps={{
          animation,
          image: require('@/images/plus.png'),
          imageWrapperStyle: {
            width: Platform.select({ default: '45%', web: '55%' }),
            height: Platform.select({ default: '45%', web: '55%' }),
          },
          imageStyle: {
            transform: [{ translateX: -25 }, { translateY: -25 }],
          },

          blurStyle: {
            opacity: Platform.select({ default: 0.75, web: 1 }),
            transform: [
              { translateX: 66 },
              { translateY: 166 },
              { scale: 0.75 },
            ],
          },
        }}
        classNameDesc="pr-4"
      />
    </Pressable>
  )
}
